var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88975 8.7796C9.0184 8.94046 9.03444 9.16557 8.93798 9.34245H8.93799C8.84154 9.53538 8.64862 9.64799 8.43954 9.64799H0.560466C0.351401 9.64799 0.158484 9.53537 0.0620226 9.34245C-0.0344387 9.16555 -0.0183991 8.94045 0.110253 8.7796L0.930292 7.67007V4.98475C0.930292 3.24825 2.20068 1.80102 3.88897 1.51153C3.72813 1.35067 3.63166 1.12557 3.63166 0.884415C3.63166 0.401994 4.03366 0 4.51608 0C4.9985 0 5.4005 0.401994 5.4005 0.884415C5.4005 1.12558 5.30404 1.35068 5.14319 1.51153C6.79947 1.80096 8.06971 3.24814 8.06971 4.98475V7.67007L8.88975 8.7796ZM5.642 10.7735C5.642 11.3844 5.1274 11.899 4.5003 11.8991C3.87319 11.8991 3.35858 11.4006 3.35858 10.7735V10.4519C3.35858 10.3715 3.42296 10.2911 3.51942 10.2911H5.48115C5.56157 10.2911 5.642 10.3555 5.642 10.4519V10.7735Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.6d4f85dde0fc6ab16455ff4a07afc30d.svg";
export { ForwardRef as ReactComponent };